
<template>
  <div>
    <div class="list-area" v-if="ready">
      <div v-if="noData" class="no-contents">조회 결과가 없습니다</div>
      <theme-detail-slider></theme-detail-slider>
    </div>
  </div>
</template>

<script>
import ThemeDetailSlider from '../components/slider/ThemeDetailSlider.vue';

export default {
  data() {
    return {
      isActiveVue: true,
      ready: false,
      noData: false,
    };
  },

  computed: {
    listItems() {
      return this.$store.getters.themeDetailList;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
  },

  watch: {
    fousedView(val) {
      if (this.isActiveVue == true && val == "default" && this.noData == true) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      }
    },
  },

  components: {
    ThemeDetailSlider
  },

  created() {
    this.$progress.$emit("on:progress");

    this.$store.commit("SET_FOCUSED_VIEW", "default");
    this.$store.commit("REMOVE_THEME_DETAIL_LIST");
    
    this.$store
      .dispatch("FETCH_THEME_DETAIL_LIST", {
        themeId: this.$route.params.themeId,
        pageNo: null,
        pageItem: 999,
        
      })
      .then((response) => {
        this.$progress.$emit("off:progress");

        if (!response || !response.data || response.data.count == 0) {
          this.noData = true;
          this.$store.commit("SET_FOCUSED_VIEW", "gnb");
        }
        this.ready = true;
      })
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.list-area {
  position: relative;
  left: 458px;
}
.no-contents {
  font-size: 32px;
  left: 320px;
  top: 460px;
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(30, 30, 30, 0.95);
}

@media all and (min-width:0px) and (max-width:1280px){
  .list-area {
    left: 0px;
    width: 100%;
    height: 100vh;
  }
  .no-contents {
    font-size: 32px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgba(30, 30, 30, 0.95);
  } 
}
</style>